'use client'

import { useEffect } from 'react'
import { initFirebaseAnalyticsIfEnabled } from './api/firebase/firebase'

export default function FirebaseAnalyticsInitializer() {
  useEffect(() => {
    void initFirebaseAnalyticsIfEnabled()
  }, [])

  return null
}
